const app = {
	metaInfo: {
		// if no subcomponents specify a metaInfo.title, this title will be used
		title: 'Argenx MG report',
		// all titles will be injected into this template
		titleTemplate: '%s | App Scaffold',
	},
	created() {
		// startup logic goes here
	},
};

export { app };
